var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.valueArray.length)?[_vm._v(" - ")]:_vm._e(),_c('transition-group',{attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.valueArray),function(valueItem,valueIndex){return _c('li',{key:`${valueIndex}-${valueItem}`,staticClass:"text-left"},[_c('ul',[_vm._v(_vm._s(valueItem))])])}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }